export function updateHeapGlobalEventProperties(updatedProperties) {
    const existingProperties = getHeapGlobalEventProperties();
    sessionStorage.setItem("heapGlobalEventProperties", JSON.stringify({
        ...existingProperties,
        ...updatedProperties,
    }));
}
export function getHeapGlobalEventProperties() {
    const existingProperties = sessionStorage.getItem("heapGlobalEventProperties");
    return existingProperties ? JSON.parse(existingProperties) : {};
}
function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.async = true;
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.head.appendChild(script);
    });
}
function waitForHeapUserId(maxWaitMs = 2000, intervalMs = 50) {
    return new Promise((resolve) => {
        const startTime = Date.now();
        const check = () => {
            if (heap === null || heap === void 0 ? void 0 : heap.userId) {
                resolve();
            }
            else if (Date.now() - startTime >= maxWaitMs) {
                console.warn("heap.userId not available after waiting, proceeding anyway");
                resolve();
            }
            else {
                setTimeout(check, intervalMs);
            }
        };
        check();
    });
}
function setupHeapStubs() {
    const methods = [
        "addEventProperties",
        "addUserProperties",
        "clearEventProperties",
        "identify",
        "resetIdentity",
        "removeEventProperty",
        "setEventProperties",
        "track",
        "unsetEventProperty",
    ];
    for (const method of methods) {
        heap[method] = (...args) => heap.push([method, ...args]);
    }
    heap.getSessionId = () => undefined;
}
export function loadHeap() {
    const appId = window.ENVIRONMENT.HEAP_APP_ID;
    window.heap = window.heap || [];
    window.heap.appid = appId;
    window.heap.config = { disableTextCapture: true, secureCookie: true };
    setupHeapStubs();
    return loadScript(`https://cdn.heapanalytics.com/js/heap-${appId}.js`).then(() => waitForHeapUserId());
}
